import { render } from "./DeathDetail.vue?vue&type=template&id=a6b407d4&scoped=true"
import script from "./DeathDetail.vue?vue&type=script&lang=js"
export * from "./DeathDetail.vue?vue&type=script&lang=js"

import "./DeathDetail.vue?vue&type=style&index=0&id=a6b407d4&scoped=true&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6b407d4"]])

export default __exports__